import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiResourceSchema } from '../common/schemas';
import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { submittedInvoiceSchema } from './schemas';
import { invoiceQueryOptions } from './useInvoice';

export const useAcquireInvoiceLock = (id: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const { data: invoice } = await fetchJson(`/invoices/${id}/lock`, {
        method: 'POST',
        schema: apiResourceSchema(submittedInvoiceSchema),
      });

      return invoice;
    },
    onSuccess: (invoice) => {
      queryClient.setQueryData(invoiceQueryOptions(invoice.id).queryKey, () => invoice);

      queryClient.invalidateQueries({ queryKey: QueryKeys.invoices.show.history(invoice.id) });
      queryClient.invalidateQueries({ queryKey: QueryKeys.invoices.index.root });
      queryClient.invalidateQueries({ queryKey: QueryKeys.statistics.dashboard });
    },
  });
};
